// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"th_a bic_a bic_r bic_j","Photos__img":"th_b bic_b"};